/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-05-09 17:03:50
 * @FilePath: /visaai-platform/src/plugins/store/getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const userInfo = state => state.userInfo.data

export const balance = state => state.balance.data

export const downloadNum = state =>  state.userInfo.downloadNum

